import { webUrl } from '@/src/utils/linkingUtils';
import { Redirect } from 'expo-router';
import type { Metadata } from 'expo-server';

const ACCESS_PASS_TITLE = 'Access Pass · Putting Scene';
const ACCESS_PASS_DESCRIPTION =
  'First dibs on secret menus, previews, original events, and member-only experiences.';
const ACCESS_PASS_IMAGE_URL =
  'https://cdn.puttingscene.com/base/APlink-previewbanner.png';

/**
 * SSR-only hook the server calls BEFORE rendering, injecting the result
 * straight into the response's `<head>` — see the fuller explanation on
 * `generateMetadata` in `app/events/[id]/index.tsx`. This page only ever
 * renders `<Redirect>`, which navigates client-side (`useFocusEffect` +
 * `router.replace`), so a crawler that doesn't run JS sees exactly this
 * head and nothing else — it never reaches `/memberships` itself.
 */
export async function generateMetadata(): Promise<Metadata> {
  const pageUrl = webUrl('/access-pass');

  return {
    title: ACCESS_PASS_TITLE,
    description: ACCESS_PASS_DESCRIPTION,
    openGraph: {
      title: ACCESS_PASS_TITLE,
      description: ACCESS_PASS_DESCRIPTION,
      url: pageUrl,
      type: 'website',
      images: [ACCESS_PASS_IMAGE_URL],
    },
    twitter: {
      card: 'summary_large_image',
      title: ACCESS_PASS_TITLE,
      description: ACCESS_PASS_DESCRIPTION,
      images: [ACCESS_PASS_IMAGE_URL],
    },
  };
}

export default function AccessPassRedirect() {
  return <Redirect href="/memberships" />;
}
